import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import {
  Mail,
  Phone,
  Clock,
  MapPin,
  MessageSquare,
  Send,
  CheckCircle,
  X,
  Zap,
  Users,
  Globe
} from 'lucide-react';
import { toast } from 'react-toastify';
import { addContact } from '../../store/contact/contactThunks';
import { useDispatch } from 'react-redux';

// Toast Component
// const Toast = ({ message, type, isVisible, onClose }) => {
//   if (!isVisible) return null;

//   return (
//     <div className={`fixed top-6 right-6 z-50 p-4 rounded-lg shadow-lg flex items-center gap-3 transition-all duration-300 transform ${
//       type === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'
//     } ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}`}>
//       {type === 'success' ? (
//         <CheckCircle className="w-5 h-5 flex-shrink-0" />
//       ) : (
//         <X className="w-5 h-5 flex-shrink-0" />
//       )}
//       <span className="font-medium">{message}</span>
//       <button onClick={onClose} className="ml-2 hover:opacity-70">
//         <X className="w-4 h-4" />
//       </button>
//     </div>
//   );
// };

const ContactUs = () => {
  // const [toast, setToast] = useState({ message: '', type: '', isVisible: false });
  const [isVisible, setIsVisible] = useState({});
  const dispatch = useDispatch()
  // IntersectionObserver for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(prev => ({ ...prev, [entry.target.id]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // Formik validation schema
  const validationSchema = Yup.object({
    fname: Yup.string().required('First name is required'),
    lname: Yup.string().required('Last name is required'),
    email: Yup.string().email('Invalid email address').required('Email is required'),
    message: Yup.string().required('Message is required')
  });

  // const showToast = (message, type) => {
  //   setToast({ message, type, isVisible: true });
  //   setTimeout(() => {
  //     setToast(prev => ({ ...prev, isVisible: false }));
  //   }, 4000);
  // };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Here you can integrate with your actual API
      console.log('Form values:', values);
      await dispatch(addContact(values)).then((resp) => {
        console.log(resp, "resprespresprespresp")
        const data = resp?.payload
        if (data?.status === 200) {
          toast.success(data?.message)
        } else {
          toast.error(data?.message)
        }
      }).catch((e) => {
        console.log(e, "1111111111111111111111111")
        toast.error(e)
      })
      resetForm();
      // showToast('Message sent successfully! We\'ll get back to you soon.', 'success');
    } catch (error) {
      // showToast('Failed to send message. Please try again.', 'error');
      toast.error("Failed to send message. Please try again.")
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 relative overflow-hidden mt-[86px]">
      {/* Toast Notification */}
      {/* <Toast
        message={toast.message}
        type={toast.type}
        isVisible={toast.isVisible}
        onClose={() => setToast(prev => ({ ...prev, isVisible: false }))}
      /> */}

      {/* Animated Background Elements */}
      {/* <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-10 -left-10 w-80 h-80 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
        <div className="absolute -top-10 -right-10 w-80 h-80 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-10 left-20 w-80 h-80 bg-pink-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
      </div> */}

      {/* Floating Particles */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className={`absolute w-2 h-2 bg-blue-400 rounded-full opacity-20 animate-float`}
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}
          />
        ))}
      </div>

      <div className="relative">
        {/* Attractive Top Section */}
        <div className="pt-12 pb-8">
          <div className="container mx-auto px-4">
            <div className="text-center max-w-4xl mx-auto animate-on-scroll" id="top-section">
              <div className={`transition-all duration-1000 ${isVisible['top-section'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                {/* Badge */}
                <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm rounded-full px-4 py-2 mb-6 shadow-lg border border-white/20">
                  <Zap className="w-4 h-4 text-[#50B5FF]" />
                  <span className="text-sm font-medium text-gray-700">Connect • Communicate • Succeed</span>
                </div>

                {/* Main Heading */}
                <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                  Let's Start a
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#50B5FF] to-purple-600"> Conversation</span>
                </h1>

                {/* Subtitle */}
                <p className="text-xl text-gray-600 mb-8 leading-relaxed max-w-2xl mx-auto">
                  Ready to transform your business communication? We're here to help you connect seamlessly across Instagram, Facebook, and WhatsApp.
                </p>

                {/* Stats Cards */}
                <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto mb-12">
                  {[
                    { icon: <Users className="w-8 h-8 text-[#50B5FF] mx-auto mb-3" />, stat: '10K+', label: 'Happy Customers' },
                    { icon: <MessageSquare className="w-8 h-8 text-green-500 mx-auto mb-3" />, stat: '1M+', label: 'Messages Processed' },
                    { icon: <Globe className="w-8 h-8 text-purple-500 mx-auto mb-3" />, stat: '50+', label: 'Countries Served' }
                  ].map((item, index) => (
                    <div
                      key={index}
                      className={`bg-white/60 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/20 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 animate-on-scroll`}
                      id={`stat-${index}`}
                    >
                      <div className={`transition-all duration-1000 ${isVisible[`stat-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: `${index * 100}ms` }}>
                        {item.icon}
                        <div className="text-2xl font-bold text-gray-900">{item.stat}</div>
                        <div className="text-sm text-gray-600">{item.label}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="pb-16">
          <div className="container mx-auto px-4">
            <div className="max-w-7xl mx-auto">
              <div className="grid lg:grid-cols-2 gap-12 items-start">

                {/* Left Side - Contact Information */}
                <div className="space-y-8 animate-on-scroll" id="contact-info">
                  <div className={`transition-all duration-1000 ${isVisible['contact-info'] ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
                    <div className="bg-white/70 backdrop-blur-md rounded-3xl p-8 shadow-2xl border border-white/30">
                      <div className="mb-8">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">Get in Touch</h2>
                        <p className="text-gray-600 text-lg leading-relaxed">
                          Ready to elevate your business communication? Our team is standing by to help you succeed.
                        </p>
                      </div>

                      <div className="space-y-6">
                        {[
                          {
                            icon: <Mail className="w-7 h-7 text-white" />,
                            gradient: 'from-[#50B5FF] to-blue-600',
                            title: 'Email',
                            content: <a href="mailto:support@yourplatform.com" className="text-gray-600 hover:text-[#50B5FF] transition-colors text-base">support@chatinject.com</a>
                          },
                          {
                            icon: <Phone className="w-7 h-7 text-white" />,
                            gradient: 'from-green-500 to-emerald-600',
                            title: 'Phone',
                            content: <a href="tel:+1-800-123-4567" className="text-gray-600 hover:text-green-600 transition-colors text-base">+1-800-123-4567</a>
                          },
                          {
                            icon: <Clock className="w-7 h-7 text-white" />,
                            gradient: 'from-orange-500 to-red-500',
                            title: 'Working Hours',
                            content: <p className="text-gray-600 text-base">Mon–Fri, 9:00 AM – 6:00 PM</p>
                          },
                          {
                            icon: <MapPin className="w-7 h-7 text-white" />,
                            gradient: 'from-purple-500 to-pink-500',
                            title: 'Address',
                            content: <p className="text-gray-600 text-base">Gujrat<br />India</p>
                          },
                          {
                            icon: <MessageSquare className="w-7 h-7 text-white" />,
                            gradient: 'from-indigo-500 to-blue-600',
                            title: '24/7 Support',
                            content: <a href="#" className="text-gray-600 hover:text-indigo-600 transition-colors text-base">Visit Help Center</a>
                          }
                        ].map((item, index) => (
                          <div
                            key={index}
                            className={`flex items-center gap-5 group cursor-pointer animate-on-scroll`}
                            id={`contact-item-${index}`}
                          >
                            <div className={`transition-all duration-1000 ${isVisible[`contact-item-${index}`] ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`} style={{ transitionDelay: `${index * 100}ms` }}>
                              <div className={`w-14 h-14 bg-gradient-to-br ${item.gradient} rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                                {item.icon}
                              </div>
                            </div>
                            <div>
                              <h3 className="font-semibold text-gray-900 text-lg">{item.title}</h3>
                              {item.content}
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Social Media */}
                      <div className="mt-10 pt-8 border-t border-gray-200">
                        <p className="text-sm text-gray-500 mb-4 font-medium">Connect with us on social media</p>
                        <div className="flex gap-4">
                          {[
                            { label: 'IG', gradient: 'bg-pink-500' },
                            { label: 'FB', gradient: 'bg-blue-600' },
                            { label: 'WA', gradient: 'bg-green-500' }
                          ].map((item, index) => (
                            <div
                              key={index}
                              className={`w-12 h-12 ${item.gradient} rounded-xl flex items-center justify-center cursor-pointer hover:scale-110 transition-transform duration-300 shadow-lg animate-on-scroll`}
                              id={`social-${index}`}
                            >
                              <div className={`transition-all duration-1000 ${isVisible[`social-${index}`] ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`} style={{ transitionDelay: `${index * 100}ms` }}>
                                <span className="text-white font-bold text-sm">{item.label}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Side - Formik Contact Form */}
                <div className="animate-on-scroll" id="contact-form">
                  <div className={`transition-all duration-1000 ${isVisible['contact-form'] ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
                    <div className="bg-white/80 backdrop-blur-md rounded-3xl p-8 shadow-2xl border border-white/30">
                      <div className="mb-8">
                        <h2 className="text-3xl font-bold text-gray-900 mb-3">Send us a Message</h2>
                        <p className="text-gray-600 text-lg">We'll respond within 24 hours. Let's make something amazing together!</p>
                      </div>

                      <Formik
                        initialValues={{
                          fname: '',
                          lname: '',
                          email: '',
                          message: ''
                        }}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                      >
                        {({ isSubmitting }) => (
                          <Form className="space-y-6">
                            {/* Name Fields */}
                            <div className="grid md:grid-cols-2 gap-4">
                              <div>
                                <label htmlFor="fname" className="block text-sm font-semibold text-gray-700 mb-2">
                                  First Name
                                </label>
                                <Field
                                  type="text"
                                  id="fname"
                                  name="fname"
                                  className="w-full px-4 py-4 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-[#50B5FF] focus:border-transparent transition-all outline-none bg-white/50 backdrop-blur-sm"
                                  placeholder="Enter your first name"
                                />
                                <ErrorMessage name="fname" component="div" className="text-red-500 text-sm mt-1" />
                              </div>

                              <div>
                                <label htmlFor="lname" className="block text-sm font-semibold text-gray-700 mb-2">
                                  Last Name
                                </label>
                                <Field
                                  type="text"
                                  id="lname"
                                  name="lname"
                                  className="w-full px-4 py-4 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-[#50B5FF] focus:border-transparent transition-all outline-none bg-white/50 backdrop-blur-sm"
                                  placeholder="Enter your last name"
                                />
                                <ErrorMessage name="lname" component="div" className="text-red-500 text-sm mt-1" />
                              </div>
                            </div>

                            {/* Email Field */}
                            <div>
                              <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                                Email Address
                              </label>
                              <Field
                                type="email"
                                id="email"
                                name="email"
                                className="w-full px-4 py-4 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-[#50B5FF] focus:border-transparent transition-all outline-none bg-white/50 backdrop-blur-sm"
                                placeholder="Enter your email address"
                              />
                              <ErrorMessage name="email" component="div" className="text-red-500 text-sm mt-1" />
                            </div>

                            {/* Message Field */}
                            <div>
                              <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">
                                Message
                              </label>
                              <Field
                                as="textarea"
                                id="message"
                                name="message"
                                rows={5}
                                className="w-full px-4 py-4 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-[#50B5FF] focus:border-transparent transition-all outline-none resize-none bg-white/50 backdrop-blur-sm"
                                placeholder="Tell us about your project or inquiry..."
                              />
                              <ErrorMessage name="message" component="div" className="text-red-500 text-sm mt-1" />
                            </div>

                            {/* Submit Button */}
                            <button
                              type="submit"
                              disabled={isSubmitting}
                              className={`w-full py-4 px-6 rounded-2xl font-bold text-white text-lg transition-all duration-300 flex items-center justify-center gap-3 shadow-xl ${isSubmitting
                                ? 'bg-gray-400 cursor-not-allowed'
                                : 'bg-gradient-to-r from-[#50B5FF] to-blue-600 hover:from-[#3DA5EF] hover:to-blue-700 hover:shadow-2xl hover:scale-[1.02] active:scale-[0.98]'
                                }`}
                            >
                              {isSubmitting ? (
                                <>
                                  <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                  Sending Message...
                                </>
                              ) : (
                                <>
                                  Send Message
                                  <Send className="w-5 h-5" />
                                </>
                              )}
                            </button>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>


                {/* Map Section */}

              </div>
              {/* <div className="mt-20 animate-on-scroll " id="map-section">
                <div className={`transition-all duration-1000 ${isVisible['map-section'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                  <div className="bg-white/70 backdrop-blur-md rounded-3xl p-8 shadow-2xl border border-white/30">
                    <div className="flex items-center gap-4 mb-8 ">
                      <div className="w-12 h-12 bg-gradient-to-br from-[#50B5FF] to-blue-600 rounded-2xl flex items-center justify-center shadow-lg">
                        <MapPin className="w-6 h-6 text-white" />
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-gray-900">Find Us Here</h3>
                        <p className="text-gray-600">Visit our office or get directions</p>
                      </div>
                    </div>

                    <div className="relative h-80 bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl overflow-hidden shadow-inner">
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="text-center">
                          <MapPin className="w-20 h-20 text-gray-400 mx-auto mb-4" />
                          <p className="text-gray-500 font-semibold text-lg">Interactive Map</p>
                          <p className="text-gray-400">123 Business Avenue, Tech City, USA</p>
                          <button className="mt-4 px-6 py-2 bg-[#50B5FF] text-white rounded-lg hover:bg-blue-600 transition-colors">
                            Get Directions
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className=" mt-20 relative h-80 bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl overflow-hidden shadow-inner">
                {/* Google Map iframe for India */}
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d36561990.401357144!2d67.12339809686956!3d20.29333258731192!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3044c8988b0618d1%3A0xb0396d4ee7f2428!2sIndia!5e0!3m2!1sen!2sin!4v1718110650429!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="absolute inset-0 w-full h-full object-cover"
                ></iframe>

                {/* Overlay Content */}
                <div className="absolute inset-0 bg-white/40 backdrop-blur-sm flex items-center justify-center">
                  <div className="text-center">
                    <MapPin className="w-20 h-20 text-gray-500 mx-auto mb-4" />
                    <p className="text-gray-700 font-semibold text-lg">Interactive Map</p>
                    <p className="text-gray-600">123 Business Avenue, Tech City, India</p>
                    <button className="mt-4 px-6 py-2 bg-[#50B5FF] text-white rounded-lg hover:bg-blue-600 transition-colors">
                      Get Directions
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default ContactUs;